import { useTranslation } from 'react-i18next'
import CommonConfirmDialog from '../common/ConfirmDialog'

/**
 * ConfirmDialog — editor's "leave without saving" confirm, wired to the
 * Zustand store (see store.ts's confirmDialog/showConfirm/hideConfirm).
 */
export default function ConfirmDialog({
  message,
  onConfirm,
  onCancel,
}: {
  message: string;
  onConfirm?: () => void;
  onCancel?: () => void;
}) {
  const { t } = useTranslation()

  return (
    <CommonConfirmDialog
      title={t('confirm.title')}
      message={message}
      confirmLabel={t('confirm.leave')}
      cancelLabel={t('confirm.cancel')}
      variant="destructive"
      onConfirm={() => onConfirm?.()}
      onCancel={() => onCancel?.()}
    />
  )
}
